import { createSelector } from 'reselect';
export const projectConfigSelector = (state) => state.projectConfig;
export const projectConfigDataSelector = createSelector(projectConfigSelector, (projectConfig) => {
    return projectConfig.data;
});
export const contractTypesSelector = createSelector(projectConfigDataSelector, (projectConfigData) => {
    return projectConfigData.CONTRACT_TYPES;
});
